import CloseController from '../../controllers/CloseController';
import { DailyQuest } from './DailyQuest';
import QuestDailyController from '../../controllers/quest/QuestDailyController';
import { QuestClaim } from './QuestClaim';
import { COMPONENTS } from '../../lib/constants';
import MainGridController from '../../controllers/grid/MainGridController';
import { QuestPageGrid } from './QuestPageGrid';
import QuestPageController from '../../controllers/quest/QuestPageController';
import QuestClaimController from '../../controllers/quest/QuestClaimController';
import UiConstants from '../../lib/UIconstants';
import { isDesktop } from 'react-device-detect';
let scale = isDesktop ? 1 : 2;
export const QuestPageClaim = {
	name: COMPONENTS.QUEST_PAGE_CLAIM,
	child: true,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: CloseController,
			name: 'CloseController',
			config: {
				closeBtn: 'close',
				remove: true
			}
		},
		{
			Controller: QuestDailyController,
			name: 'QuestDailyController',
			config: {
				item: 'quest_daily',
				val: 'quest_daily',
				btns: [UiConstants.FTR_QUEST_GO, 'daily_btn']
			}
		},
		{
			Controller: MainGridController,
			name: 'QuestPageGrid',
			config: QuestPageGrid
		},
		{
			Controller: QuestPageController,
			name: 'QuestPageController',
			config: {
				holder: 'quest_view_holder_up',
				name: 'quest_claim'
			}
		},
		{
			Controller: QuestClaimController,
			name: 'QuestClaimController',
			config: {
				id: 1,
				item: 'quest_claim_1',
				color: 'rgba(113, 178, 238, 1)',
				img: 'quest_reward_icon_1',
				quests: [
					'quest_claim_1',
					'quest_claim_2',
					'quest_claim_3',
					'quest_claim_4'
				]
			}
		},
		{
			Controller: QuestClaimController,
			name: 'QuestClaimController',
			config: {
				id: 2,
				item: 'quest_claim_2',
				color: 'rgba(183, 238, 113, 1)',
				img: 'quest_reward_icon_2',
				quests: [
					'quest_claim_1',
					'quest_claim_2',
					'quest_claim_3',
					'quest_claim_4'
				]
			}
		},
		{
			Controller: QuestClaimController,
			name: 'QuestClaimController',
			config: {
				id: 3,
				item: 'quest_claim_3',
				color: 'rgba(183, 113, 238, 1)',
				img: 'quest_reward_icon_3',
				quests: [
					'quest_claim_1',
					'quest_claim_2',
					'quest_claim_3',
					'quest_claim_4'
				]
			}
		},
		{
			Controller: QuestClaimController,
			name: 'QuestClaimController',
			config: {
				id: 4,
				item: 'quest_claim_4',
				color: 'rgba(238, 113, 173, 1)',
				img: 'quest_reward_icon_4',
				quests: [
					'quest_claim_1',
					'quest_claim_2',
					'quest_claim_3',
					'quest_claim_4'
				]
			}
		}
	],
	components: [
		{
			name: 'quest_view_holder_up',
			type: 'Sprite',
			components: [
				{
					name: 'bg',
					type: 'Sprite',
					img: 'reel_bg',
					position: { x: 0, y: 0 },
					alpha: 0.6
				},
				{
					name: 'quest_page_secondary_bg',
					type: 'Sprite',
					img: 'quest_page_secondary_bg',
					position: { x: 34, y: 272 },
					scale: { x: scale, y: scale }
				},
				{
					name: 'quest_featured_img',
					type: 'Sprite',
					img: 'quest_featured_img',
					position: { x: 16, y: 54 }
				},
				{
					name: 'header',
					type: 'CustomText',
					text: 'QUEST_DAILY_HEADER',
					position: { x: 380, y: 25 }
				},
				{
					name: 'close',
					type: 'Button',
					components: [
						{
							name: 'bg',
							type: 'MouseOverSprite',
							img: 'close_icon',
							imgHover: 'close_icon_hovered',
							position: { x: 1080, y: 15 }
						}
					]
				},
				{
					name: 'quest_daily',
					position: { x: 53, y: 0 },
					type: 'VisualComponent',
					component: DailyQuest
				},
				{
					name: 'quest_claim_1',
					position: { x: 58, y: 306 },
					type: 'VisualComponent',
					component: QuestClaim
				},
				{
					name: 'quest_claim_2',
					position: { x: 323, y: 306 },
					type: 'VisualComponent',
					component: QuestClaim
				},
				{
					name: 'quest_claim_3',
					position: { x: 586, y: 306 },
					type: 'VisualComponent',
					component: QuestClaim
				},
				{
					name: 'quest_claim_4',
					position: { x: 850, y: 306 },
					type: 'VisualComponent',
					component: QuestClaim
				}
			]
		}
	]
};
